module.exports = __webpack_public_path__ + "static/assets/ff3c49d02045a3d05a72f4c004cdb80c.svg";